import {AuthenticationSvc} from '../services/AuthenticationSvc';
import {Utils} from '../underscore-extensions';
import {AnalyticSvc} from '../services/AnalyticSvc';

export const setWrapper = (() => {
    let headerShown    = false;
    const enableFooter = () => {
        if (!headerShown) {
            try {
                document.querySelector('footer').style.display = 'block';
                headerShown                                    = true;
            } catch (e) {
                setTimeout(() => enableFooter(), 100);
            }
        }
    };
    return (wrapper?: string) => ({
        setWrapper: /*@ngInject*/ ($rootScope: ng.IRootScopeService, $state: ng.ui.IStateService) => {
            const event = $rootScope.$on('$stateChangeSuccess', () => {
                const product           = Utils.getProductByState($state);
                $rootScope.wrapperClass = `${wrapper} wrapper-${product}`;
                enableFooter();
                event();
            });
        }
    });
})();

export function setTitle(title?: string) {
    return {
        setTitle: /*@ngInject*/ ($rootScope: ng.IRootScopeService) => {
            const event = $rootScope.$on('$stateChangeSuccess', () => {
                $rootScope.setTitle(title);
                event();
            });
        }
    };
}

export function trackVisit(name?: string, params = {}) {
    return {
        trackVisit: /*@ngInject*/ (analyticSvc: AnalyticSvc) => {
            analyticSvc.visitPage(name, params);
        }
    };
}


// if mod is function, execute it, if array execute all functions inside
export const loadModule = (mod: any | any[]) => (() => {
    const applyOr = (f: any | any[], or: any | any[]) => _.isFunction(f) ? f() : or;
    return {
        loadModule: /*@ngInject*/ ($ocLazyLoad: oc.ILazyLoad) => {
            const applied = applyOr(mod, _.isArray(mod) ? mod.map(m => applyOr(m, m)) : mod);
            if (applied && applied.then) {
                return applied.then((modules: any) => $ocLazyLoad.load(
                    _.flatten([modules])
                        .map(m => Object.assign({}, m, {files: m.files.filter((f: any) => !_.isEmpty(f))}))
                ));
            } else {
                return $ocLazyLoad.load(applied);
            }
        }
    };
})();

export const redirect = (condition: boolean | Function, callback: Function) =>
    new Promise(resolve => (_.isFunction(condition) ? condition() : condition) ? callback() : resolve());

export const redirectResolve = (condition: (() => boolean) | boolean, path = '/landing') => ({
    redirect: ['$location', ($location: ng.ILocationService) =>
        redirect(condition, () => $location.path(path))
    ]
});

export const redirectForLogin = (path?: string, redirectPath?: string) => ({
    redirect: /*@ngInject*/ ($location: ng.ILocationService,
                             AuthenticationSvc: AuthenticationSvc) =>
        redirect(options.user.anonymous, () => {
            const currentUrl  = $location.url() + location.search;
            const state       = Utils.getProduct(window.location.pathname).toLowerCase();
            const redirectUrl = `/${state}/landing`;
            $location.path(redirectUrl);
            setTimeout(() => AuthenticationSvc.toggleLoginModal(path || currentUrl), 0);
        })
});

export const nullToEmptyString = (str?: string) => str ? str : '';

export function stateStudioRedirect($stateProvider: ng.ui.IStateProvider,
                                    config: ng.ui.IState,
                                    stateName: string) {
    config              = Object.assign({}, config);
    const url           = typeof config.url === 'string' && config.url;
    const isStudioState = /^studio-/.test(stateName) || /^\/studio\//.test(url);

    if (isStudioState) {
        const newStateName = stateName.replace('studio-', '').replace('studio/', '');
        const newUrl       = url.replace('studio/', '');

        $stateProvider.state(newStateName, {
            url: newUrl,
            params: config.params,
            resolve: {
                redirect: /*@ngInject*/ ($location: ng.ILocationService) => {
                    const path           = `/studio${$location.url()}`;
                    const hasParentState = /\./g.test(stateName);

                    !hasParentState && Utils.redirect(path, $location, true);
                }
            }
        });
    }
    return config;
}

export function extendState($stateProvider: ng.ui.IStateProvider) {
    const state = $stateProvider.state.bind($stateProvider);

    $stateProvider.state = (...params: any[]) => {
        const config: ng.ui.IState = params.pop();
        const stateName            = params.length !== 0 && params[0];
        params.push(stateStudioRedirect($stateProvider, config, stateName));
        return state(...params);
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/routes/RouteUtils.ts